import { CheckList as CheckList_kojaro } from './CheckList.kojaro';
import { CheckList as CheckList_phosphor } from './CheckList.phosphor';
import { CheckList as CheckList_zoomg } from './CheckList.zoomg';
import { CheckList as CheckList_zoomit } from './CheckList.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return CheckList_kojaro;

    case 'zoomg':
      return CheckList_zoomg;

    case 'phosphor':
      return CheckList_phosphor;

    default:
      return CheckList_zoomit;
  }
};

export const CheckList = IconRenderer();
